import request from '@/utils/request'

//发票申请页面
export function listCapital(query) {
  return request({
    url: '/user/invoice/listCapital',
    method: 'post',
    params: query,
  })
}

export function getSetting(query) {
  return request({
    url: '/user/invoice/getSetting',
    method: 'post',
    params: query,
  })
}

export function getDefaultHeader(query) {
  return request({
    url: '/user/invoice/getDefaultHeader',
    method: 'post',
    params: query,
  })
}

export function getDefaultAddress(query) {
  return request({
    url: '/user/invoice/getDefaultAddress',
    method: 'post',
    params: query,
  })
}

export function listAddress(query) {
  return request({
    url: '/user/invoice/listAddress',
    method: 'post',
    params: query,
  })
}

export function checkApply(query) {
  return request({
    url: '/user/invoice/checkApply',
    method: 'post',
    params: query,
  })
}

export function applyInvoice(query) {
  return request({
    url: '/user/invoice/applyInvoice',
    method: 'post',
    params: query,
  })
}

//发票列表页面
export function listInvoice(query) {
  return request({
    url: '/user/invoice/listInvoice',
    method: 'post',
    params: query,
  })
}

//发票信息管理页面
export function listHeader(query) {
  return request({
    url: '/user/invoice/listHeader',
    method: 'post',
    params: query,
  })
}

export function addHeader(query) {
  return request({
    url: '/user/invoice/addHeader',
    method: 'post',
    data: query,
  })
}

export function updateHeader(query) {
  return request({
    url: '/user/invoice/updateHeader',
    method: 'post',
    data: query,
  })
}

//寄送地址页面
export function addAddress(query) {
  return request({
    url: '/user/invoice/addAddress',
    method: 'post',
    data: query,
  })
}

export function updateAddress(query) {
  return request({
    url: '/user/invoice/updateAddress',
    method: 'post',
    data: query,
  })
}

export function setDefaultAddress(query) {
  return request({
    url: '/user/invoice/setDefaultAddress',
    method: 'post',
    params: query,
  })
}

export function delAddress(query) {
  return request({
    url: '/user/invoice/delAddress',
    method: 'post',
    params: query,
  })
}

//实名认证页面
export function getAuthResult(query) {
  return request({
    url: '/user/enterprise/auth/result',
    method: 'get',
    params: query,
  })
}

export function editAuth(query) {
  return request({
    url: '/user/enterprise/auth',
    method: 'get',
    params: query,
  })
}

export function getIpSetting() {
  return request({
    url: '/user/ip/getSetting',
    method: 'post',
    // params: query,
  })
}

export function updateIpSetting(query) {
  return request({
    url: '/user/ip/update',
    method: 'post',
    data: query,
  })
}

export function changeKeySms() {
  return request({
    url: '/user/changeKeySend',
    method: 'get',
    // data: query,
  })
}

export function changeKey(query) {
  return request({
    url: '/user/changeKey',
    method: 'get',
    params: query,
  })
}

//获取数据接口详情
export function getDataDetail(query) {
  return request({
    url: '/user/api/list',
    method: 'post',
    params: query,
  })
}

//获取数据接口监控
export function getMonitorList(query) {
  return request({
    url: '/user/api/monitor',
    method: 'post',
    params: query,
  })
}


//获取数据接口详情-日志查询
export function getDataJournal(query) {
  return request({
    url: '/user/api/apiLog',
    method: 'post',
    params: query,
  })
}

//获取数据接口详情-数据监控
export function getDataMonitor(query) {
  return request({
    url: '/user/api/dataMonitor',
    method: 'post',
    params: query,
  })
}

//获取数据接口详情-历史查询
export function getDataHistory(query) {
  return request({
    url: '/user/api/history',
    method: 'post',
    params: query,
  })
}

//获取购买套餐列表
export function getCustom(query) {
  return request({
    url: '/user/custom/list',
    method: 'post',
    params: query,
  })
}

//获取账户信息
export function getCustomCheck(query) {
  return request({
    url: '/user/custom/check',
    method: 'get',
    params: query,
  })
}

export function getWarning() {
  return request({
    url: '/user/custom/getWarning',
    method: 'post',
    // data: query,
  })
}

export function saveWarning(query) {
  return request({
    url: '/user/custom/saveWarning',
    method: 'post',
    params: query,
  })
}

export function getDataPackage(query) {
  return request({
    url: '/user/custom/dataPackage',
    method: 'post',
    params: query,
  })
}

export function customCheck(query) {
  return request({
    url: '/user/custom/check',
    method: 'get',
    params: query,
  })
}

//获取用户充值记录列表（金币明细）
export function goldDetailed(query) {
  return request({
    url: '/userGoldDeposits/getGoldDepositsList',
    method: 'get',
    params: query,
  })
}

//获取用户充值记录列表（金币明细）
export function noticeList(query) {
  return request({
    url: '/announcement/list',
    method: 'get',
    params: query,
  })
}

//个人认证
export function personalAuth(query) {
  return request({
    url: '/user/auth',
    method: 'post',
    params: query,
  })
}

export function payAuth(query) {
  return request({
    url: '/user/auth/result',
    method: 'get',
    params: query,
  })
}

//获取通知列表
export function newGetNotice() {
  return request({
    url: '/announcement/recent',
    method: 'get',
  })
}

//将通知标为已读
export function readNotice(query) {
  return request({
    url: '/announcement/read/message',
    method: 'post',
    params: query
  })
}

//将通知标为已读
export function exportFile(query) {
  return request({
    url: '/export/consumption',
    method: 'get',
    params: query
  })
}






// WEBPACK FOOTER //
// ./src/api/user/index.js